/** Rendert genau ein Feld je nach Status: Row · Card · Done · Error. */
import { attrLabel } from './labels'
import { OptimierungDoneRow } from './OptimierungDoneRow'
import { OptimierungErrorCard } from './OptimierungErrorCard'
import { OptimierungFieldRow } from './OptimierungFieldRow'
import { OptimierungSuggestionCard } from './OptimierungSuggestionCard'
import type { OptimierungField } from './optimierungenTypes'

export interface OptimierungFieldItemProps {
  field: OptimierungField
  channelName: string
  onOptimize: (code: string) => void
  onApply: (field: OptimierungField) => void
  onDiscard: (code: string) => void
  onConfigure?: () => void
  onUndo?: (code: string) => void
}

export function OptimierungFieldItem({
  field,
  channelName,
  onOptimize,
  onApply,
  onDiscard,
  onConfigure,
  onUndo,
}: OptimierungFieldItemProps) {
  const { attributeCode, status } = field

  if (status === 'suggestion' && field.suggestion) {
    return (
      <OptimierungSuggestionCard
        field={field.suggestion}
        cost={field.cost}
        channelName={channelName}
        onApply={() => onApply(field)}
        onRegenerate={() => onOptimize(attributeCode)}
        onDiscard={() => onDiscard(attributeCode)}
      />
    )
  }

  if (status === 'applied') {
    return (
      <OptimierungDoneRow
        attributeCode={attributeCode}
        channelName={channelName}
        snippet={field.appliedSnippet ?? ''}
        meta={`−${field.cost} Cr`}
        onUndo={onUndo ? () => onUndo(attributeCode) : undefined}
      />
    )
  }

  if (status === 'error') {
    return (
      <OptimierungErrorCard
        attributeCode={attributeCode}
        kind={field.errorKind ?? 'failed'}
        detail={field.errorDetail}
        onRetry={() => onOptimize(attributeCode)}
        onConfigure={onConfigure}
        onDiscard={() => onDiscard(attributeCode)}
      />
    )
  }

  // rest | busy → Feldzeile
  return (
    <OptimierungFieldRow
      kind={field.kind}
      name={attrLabel(attributeCode)}
      status={field.statusLabel}
      reason={field.reason}
      cost={field.cost}
      rowState={status === 'busy' ? 'busy' : 'open'}
      onOptimize={() => onOptimize(attributeCode)}
    />
  )
}
